import {SurveyApi} from '@/api/survey-api';
import {BookingApi} from '@/api/booking-api';

export const SurveyUtils = {
  methods: {
    /**
     * @param {BookingSurveyDto} booking
     * @return {boolean}
     */
    canSurveyEmailBeSent(booking) {
      return this.hasAnyPermission('SURVEY_EDIT') && !booking.canceled && (booking.surveyResult == null || booking.surveyResult.answeredAt == null) && new Date(booking.checkoutAt) < new Date()
    },

    canSurveyResultBeUpdated(surveyResult) {
      return this.hasAnyPermission('SURVEY_REVIEW') && surveyResult && ['ANSWERED', 'REVIEWED'].includes(surveyResult.status);
    },

    /**
     * @param {BookingSurveyDto} booking
     * @return {boolean}
     */
    _isSurveyActivated(booking)
    {
      return booking?.surveyStatus === 'NEEDED';
    },

    /**
     * @param {BookingSurveyDto} booking
     * @return {boolean}
     */
    canAutoSurveyBeDeactivated(booking) {
      return this.hasAnyPermission('SURVEY_EDIT') && booking.surveyResult == null && this._isSurveyActivated(booking);
    },
    /**
     * @param {BookingSurveyDto} booking
     * @return {boolean}
     */
    canAutoSurveyBeActivated(booking) {
      return this.hasAnyPermission('SURVEY_EDIT') && !this._isSurveyActivated(booking) && new Date(booking.checkoutAt) > new Date();
    },

    /**
     * @param {BookingSurveyDto} booking
     */
    sendSurveyMail (booking) {
      let request = SurveyApi.sendGuestMail(booking.id);
      request.then(response => {
        this.showSuccessNotification(this.trans('email.titleStatusPending'));
      });
      return request;
    },

    /**
     * @param {BookingSurveyDto} booking
     */
    toggleBookingSurveyStatus (booking) {
      let request = BookingApi.updateBooking(booking.id, {surveyStatus: !this._isSurveyActivated(booking) ? 'NEEDED' : 'NOT_NEEDED'});
      request.then(response => {
        this.showSuccessNotification(this.trans('notifications.successfully_saved'));
      });
      request.catch(this.handleErrorResponse);
      return request;
    },

    /**
     * @param {SurveyResultDto} surveyResult
     */
    toggleSurveyReviewed (surveyResult) {
      let surveyResultUpdateRequest = {
        reviewedAt: surveyResult.reviewedAt === null ? new Date() : null
      };

      let request = SurveyApi.updateSurveyResult(surveyResult.bookingId, surveyResultUpdateRequest)
      request.then(response => {
        this.showSuccessNotification(this.trans('notifications.successfully_saved'));
      });
      request.catch(this.handleErrorResponse);
      return request;
    }
  },
};
